<template>
  <div class="single-image-upload">
    <template v-if="currentValue">
      <div class="preview-wrap" :style="previewWrapStyle" @mouseenter="hoverPreview = true" @mouseleave="hoverPreview = false">
        <img :src="currentValue" class="icon-preview" :alt="tip" />
        <div class="preview-mask" :class="{ visible: hoverPreview }">
          <i class="el-icon-delete remove-icon" @click.stop="handleRemove" />
        </div>
      </div>
    </template>
    <div v-else class="uploader-wrap" :style="uploaderStyle" v-loading="uploading" element-loading-text="上传中">
      <el-upload
        class="icon-uploader"
        :show-file-list="false"
        :http-request="handleUpload"
        :before-upload="beforeUpload"
        :accept="fileTypes.join(',')"
        action="#"
        :style="uploaderStyle"
        :disabled="uploading"
      >
        <i class="el-icon-plus icon-uploader-icon" />
      </el-upload>
    </div>
    <div v-if="tip" class="upload-tip">{{ tip }}</div>
  </div>
</template>

<script>
import { uploadToS3 } from '@/api/upload'

const ALLOWED_TYPES = ['image/jpeg', 'image/jpg', 'image/png']

export default {
  name: 'SingleImageUpload',
  props: {
    value: {
      type: String,
      default: '',
    },
    size: {
      type: [String, Number],
      default: 120,
    },
    // tip: {
    //   type: String,
    //   default: '支持 jpg、jpeg、png 格式',
    // },
    maxSizeMb: {
      type: Number,
      default: 5,
    },
    allowedTypes: {
      type: Array,
      default: () => ['jpeg', 'jpg', 'png'],
    },
  },
  data() {
    return {
      hoverPreview: false,
      uploading: false,
    }
  },
  computed: {
    tip() {
      return '支持 ' + this.allowedTypes.join(', ') + ' 格式'
    },
    fileTypes() {
      return this.allowedTypes.map(type => 'image/' + type)
    },
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    sizePx() {
      const n = Number(this.size)
      return Number.isNaN(n) ? 120 : n
    },
    previewWrapStyle() {
      return {
        width: `${this.sizePx}px`,
        height: `${this.sizePx}px`,
      }
    },
    uploaderStyle() {
      return {
        width: `${this.sizePx}px`,
        height: `${this.sizePx}px`,
      }
    },
  },
  methods: {
    beforeUpload(file) {
      const type = file.type && file.type.toLowerCase()
      console.log('type', type)
      if (!this.fileTypes.includes(type)) {
        this.$message.error('只能上传 jpg、jpeg、png 格式的图片')
        return false
      }
      const maxBytes = this.maxSizeMb * 1024 * 1024
      if (file.size > maxBytes) {
        this.$message.error(`图片大小不能超过 ${this.maxSizeMb}M`)
        return false
      }
      return true
    },
    async handleUpload({ file }) {
      if (!this.beforeUpload(file)) return
      this.uploading = true
      try {
        const result = await uploadToS3(file)
        if (result.success && result.data && result.data.objectUrl) {
          this.currentValue = result.data.objectUrl
          this.$message.success('上传成功')
        } else {
          this.$message.error(result.error || '上传失败')
        }
      } catch (e) {
        this.$message.error(e && e.message ? e.message : '上传失败')
      } finally {
        this.uploading = false
      }
    },
    handleRemove() {
      this.currentValue = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.single-image-upload {
  display: inline-block;
}

.preview-wrap {
  position: relative;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;
}
.preview-wrap .icon-preview {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.preview-mask {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}
.preview-mask.visible {
  opacity: 1;
}
.remove-icon {
  font-size: 28px;
  color: #fff;
  cursor: pointer;
}

.uploader-wrap {
  position: relative;
  display: inline-block;
}
.uploader-wrap .icon-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.uploader-wrap .icon-uploader:hover:not(.is-disabled) {
  border-color: #409eff;
}
.uploader-wrap .icon-uploader.is-disabled {
  cursor: not-allowed;
}
.icon-uploader-icon {
  font-size: 28px;
  color: #8c939d;
}

.upload-tip {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
</style>
